import { call, put } from 'redux-saga/effects';

import api from 'api';
import { IGetAccessTokenResponse } from 'api/components/Auth/types';
import { setTokenAccess } from 'api/utils/tokenManagement';

import { getAccessTokenRequest } from 'store/api/actions';
import { getAuthTokenRefresh } from 'store/auth/accessors';
import { logout } from 'store/auth/actions';
import { openModal as openModalAction } from 'store/modals/actions';

import { reportDatadogRumError } from 'services/DataDog';
import { ERROR_LEVELS } from 'services/Sentry/constants';
import sentry from 'services/Sentry/SentryInstance';

import { ModalName } from 'modals/types';

export function* getAccessToken({ payload }: ReturnType<typeof getAccessTokenRequest>) {
    const { onSuccess, onError, onFinally } = payload;

    try {
        const refresh = getAuthTokenRefresh();

        if (refresh) {
            const response: IGetAccessTokenResponse = yield call(api.auth.getAccessToken, { refresh });

            const { access } = response.data;

            yield call(setTokenAccess, access);
            yield call(onSuccess, access);
        } else {
            yield call(onError);
            yield put(logout());
        }
    } catch (error: any) {
        const status = error?.response?.status;

        if (status === 403 || status === 400) {
            if (status === 400) sentry.sentrySagaLog(error, 'getAccessToken', ERROR_LEVELS.CRITICAL);

            yield put(logout());

            if (status === 403) {
                reportDatadogRumError(error, {
                    reason: '403 Forbidden Token Refresh',
                });

                put(openModalAction(ModalName.NoLogInModal));
            }
        }

        yield call(onError);
    } finally {
        yield call(onFinally);
    }
}
